export enum TerminationReasons {
  RENONC = "RENONC",
  VENTEDEM = "VENTEDEM",
  DECES = "DECES",
  ECHEANCE = "ECHEANCE",
  AUTRE = "AUTRE",
}
